import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  Grid,
  Chip as MuiChip,
  Divider as MuiDivider,
  Typography,
  Stack,
} from "@mui/material";
import { toast } from "react-toastify";

import {
  renderColumnDataGrid,
  getSubFormContrlsObj,
  saveSubFormRow,
  deleteSubFormRow,
  parseAndRound,
} from "src/utils/amUtils";
// import AMFooterTable from "src/pages/components/AMFooterTable";
import AMFooterTable from "src/pages/components/AMFooterTableByDataGrid";
import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";
import LegerWithSubLedgers from "src/pages/pages/gaTrx/LegerWithSubLedgers";
import _ from "lodash";
import { getCaption } from "src/utils/dictionary";

const Chip = styled(MuiChip)(spacing);

function GATrxFooter({
  formControls,
  tableData,
  title,
  setTableData,
  ledgers,
}) {
  const [columns, setColumns] = useState([]);
  const [summary, setSummary] = useState({
    rowsCount: 0,
    totalCredit: 0,
    totalDebit: 0,
  });

  //initColumns -- matrial-table
  // useEffect(() => {
  //   const initColumns = () => {
  //     const columns = [];
  //     columns.push({
  //       field: "actions",
  //       type: "actions",
  //       width: 80,
  //       getActions: (params) => [
  //         <GridActionsCellItem
  //           icon={<DeleteIcon />}
  //           label="Delete"
  //           onClick={() => alert(params.id)}
  //           // onClick={deleteUser(params.id)}
  //         />,
  //         <GridActionsCellItem
  //           icon={<SecurityIcon />}
  //           label="Toggle Admin"
  //           onClick={() => alert(params.id)}
  //           //onClick={toggleAdmin(params.id)}
  //           showInMenu
  //         />,
  //         <GridActionsCellItem
  //           icon={<FileCopyIcon />}
  //           label="Duplicate User"
  //           onClick={() => alert(params.id)}
  //           //onClick={duplicateUser(params.id)}
  //           showInMenu
  //         />,
  //       ],
  //     });
  //     columns.push(renderColumn("id", {}, { hidden: true }));
  //     columns.push(renderColumn("ledgerId", {}, { hidden: true }));
  //     columns.push(renderColumn("subLedgerAId", {}, { hidden: true }));
  //     columns.push(renderColumn("subLedgerBId", {}, { hidden: true }));
  //     columns.push(renderColumn("subLedgerCId", {}, { hidden: true }));
  //     columns.push(renderColumn("subLedgerDId", {}, { hidden: true }));
  //     columns.push(renderColumn("serial", formControls.serial));
  //     columns.push(renderColumn("ledgerName", formControls.ledgerName));
  //     columns.push(
  //       renderColumn("subLedgerA_Name", formControls.subLedgerA_Name)
  //     );
  //     columns.push(
  //       renderColumn("subLedgerB_Name", formControls.subLedgerB_Name)
  //     );
  //     columns.push(
  //       renderColumn("subLedgerC_Name", formControls.subLedgerC_Name)
  //     );
  //     columns.push(
  //       renderColumn("subLedgerD_Name", formControls.subLedgerD_Name)
  //     );
  //     columns.push(renderColumn("displayCredit", formControls.displayCredit));
  //     columns.push(renderColumn("displayDebit", formControls.displayDebit));
  //     columns.push(renderColumn("lineNotes", formControls.lineNotes));

  //     return columns;
  //   };

  //   setColumns(initColumns());
  // }, [formControls]);

  //initColumns

  //initColumns;
  useEffect(() => {
    const initColumns = () => {
      const columns = [];
      columns.push(renderColumnDataGrid("id", {}, { hide: true }));
      columns.push(renderColumnDataGrid("ledgerId", {}, { hide: true }));
      columns.push(renderColumnDataGrid("subLedgerAId", {}, { hide: true }));
      columns.push(renderColumnDataGrid("subLedgerBId", {}, { hide: true }));
      columns.push(renderColumnDataGrid("subLedgerCId", {}, { hide: true }));
      columns.push(renderColumnDataGrid("subLedgerDId", {}, { hide: true }));
      columns.push(renderColumnDataGrid("serial", formControls.serial));
      columns.push(renderColumnDataGrid("ledgerName", formControls.ledgerName));
      columns.push(
        renderColumnDataGrid("subLedgerA_Name", formControls.subLedgerA_Name)
      );
      columns.push(
        renderColumnDataGrid("subLedgerB_Name", formControls.subLedgerB_Name)
      );
      columns.push(
        renderColumnDataGrid("subLedgerC_Name", formControls.subLedgerC_Name)
      );
      columns.push(
        renderColumnDataGrid("subLedgerD_Name", formControls.subLedgerD_Name)
      );
      columns.push(
        renderColumnDataGrid("displayDebit", formControls.displayDebit)
      );
      columns.push(
        renderColumnDataGrid("displayCredit", formControls.displayCredit)
      );
     
      columns.push(renderColumnDataGrid("notes", formControls.lineNotes));

      return columns;
    };

    setColumns(initColumns());
  }, [formControls]);

  useEffect(() => {
    const newSummary = {
      rowsCount: 0,
      totalCredit: 0,
      totalDebit: 0,
    };

    if (tableData && tableData.length) {
      newSummary.rowsCount = tableData.length;
      newSummary.totalCredit = parseAndRound(
        _.sumBy(tableData, function (o) {
          return parseAndRound(o.displayCredit);
        }),
        //It sums as string _.sumBy(tableData, "displayCredit"),
        4
      );
      newSummary.totalDebit = parseAndRound(
        _.sumBy(tableData, function (o) {
          return parseAndRound(o.displayDebit);
        }),
        4
      );
    }
    setSummary((state) => ({ ...state, ...newSummary }));
  }, [tableData]);

  const handleLederWithSubLedgerSelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    try {
      let colName = "";
      switch (fieldName) {
        case "ledgerId":
          colName = "ledgerName";
          break;
        case "subLedgerAId":
          colName = "subLedgerA_Name";
          break;

        case "subLedgerBId":
          colName = "subLedgerB_Name";
          break;

        case "subLedgerCId":
          colName = "subLedgerC_Name";
          break;

        case "subLedgerDId":
          colName = "subLedgerD_Name";
          break;

        default:
          break;
      }
      if (colName && value) setSubFormState({ [colName]: value.textField });
      handleSelectedIndexChange(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };
  //#region Add/Edit Form

  const {
    state: subFormState,
    errors: subFormErrors,
    handleSetState: setSubFormState,
    handleSetFullState: setSubFormFullState,
    handleSelectedIndexChange,
    renderFormInput,
    vaLidateFormData: defaultValidateSubFormData,
  } = useForm({
    menuItemCode: "",
    nextCodeField: "",
    getNextCodeFunc: null,
    getByIdFunc: null,
    saveFunction: null,
    deleteFunction: null,
    isSubForm: true,
    subFormControls: getSubFormContrlsObj(formControls, [
      "ledgerId",
      "subLedgerAId",
      "subLedgerBId",
      "subLedgerCId",
      "subLedgerDId",
      "lineNotes",
      "displayCredit",
      "displayDebit",
    ]), //you have to filter because of validation schema
  });

  const gridItemProps = {
    lg: 2,
    md: 2,
    sm: 3,
    xs: 12,
    style: { paddingBottom: 5, paddingTop: 5 },
  };

  // const handleCountrySelectedIndexChanged = (
  //   event,
  //   value,
  //   reason,
  //   fieldName
  // ) => {
  //   try {
  //     setSubFormState({ ...subFormState, lineCountryName: value.textField });
  //     handleSelectedIndexChange(event, value, reason, fieldName);
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const editForm = (
    <Grid container spacing={4}>
      {renderFormInput(
        "serial",
        Enums.ControlType.TextField,
        {
          disabled: true,
          style: { maxWidth: 100 },
        },
        gridItemProps
      )}
      <LegerWithSubLedgers
        ledgers={ledgers}
        menuItemCode=""
        formControls={formControls || {}}
        errors={subFormErrors || {}}
        onChange={handleLederWithSubLedgerSelectedIndexChanged}
        ledgerId={subFormState["ledgerId"] || ""}
        subLedgerAId={subFormState["subLedgerAId"] || ""}
        subLedgerBId={subFormState["subLedgerBId"] || ""}
        subLedgerCId={subFormState["subLedgerCId"] || ""}
        subLedgerDId={subFormState["subLedgerDId"] || ""}
        ledgerIdFieldName="ledgerId"
        subLedgerAIdFieldName="subLedgerAId"
        subLedgerBIdFieldName="subLedgerBId"
        subLedgerCIdFieldName="subLedgerCId"
        subLedgerDIdFieldName="subLedgerDId"
        gridItemProps={{
          lg: 5,
          md: 5,
          sm: 12,
          xs: 12,
          style: { paddingBottom: 5, paddingTop: 5 },
        }}
      />
      <Grid item xs={12}>
        <Grid container spacing={4}>
          {renderFormInput(
            "displayDebit",
            Enums.ControlType.TextField,
            {},
            {
              lg: 2,
              md: 2,
              sm: 3,
              xs: 12,
              style: { paddingBottom: 5, paddingTop: 5 },
            }
          )}
          {renderFormInput(
            "displayCredit",
            Enums.ControlType.TextField,
            {},
            {
              lg: 2,
              md: 2,
              sm: 3,
              xs: 12,
              style: { paddingBottom: 5, paddingTop: 5 },
            }
          )}

          {renderFormInput(
            "notes",
            Enums.ControlType.TextField,
            {},
            {
              lg: 8,
              md: 8,
              sm: 6,
              xs: 12,
              style: { paddingBottom: 5, paddingTop: 5 },
            }
          )}
        </Grid>
      </Grid>
    </Grid>
  );
  //#endregion

  //const [data, setData] = useState([]);

  // useEffect(() => {
  //   setData(tableData);
  // }, [tableData]);

  // const handleSetTrxFooter = (newTrxFooter) => {
  //   // const newState = { ...values };
  //   // newState.trxFooter = [...newTrxFooter];
  //   setData(newTrxFooter);
  // };

  const validateSubFormData = () => {
    if (defaultValidateSubFormData()) {
      const d = parseAndRound(subFormState.displayDebit);
      const c = parseAndRound(subFormState.displayCredit);
      if ((c === 0) & (d === 0)) {
        toast.error(getCaption("enter_credit_or_debit"));
        return false;
      }
      if ((c !== 0) & (d !== 0)) {
        toast.error(getCaption("cant_enter_credit_and_debit_same_time"));
        return false;
      }

      //#region Validate ledger with subledger
      const rowIndex = ledgers.findIndex(
        (x) => x.valueField == subFormState.ledgerId
      );
      if (rowIndex === -1) {
        toast.error(getCaption("error_in_ledger"));
        return false;
      }
      const ledger = ledgers[rowIndex];
      if (ledger && ledger.requireSubLedgerA && !subFormState.subLedgerAId) {
        toast.error(getCaption("subledger_a_required"));
        return false;
      }
      if (ledger && ledger.requireSubLedgerB && !subFormState.subLedgerBId) {
        toast.error(getCaption("subledger_b_required"));
        return false;
      }
      if (ledger && ledger.requireSubLedgerC && !subFormState.subLedgerCId) {
        toast.error(getCaption("subledger_c_required"));
        return false;
      }
      if (ledger && ledger.requireSubLedgerD && !subFormState.subLedgerDId) {
        toast.error(getCaption("subledger_d_required"));
        return false;
      }
      //#endRegion

      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {columns.length > 0 && (
        <AMFooterTable
          title={title}
          columns={columns}
          tableData={tableData}
          setTableData={setTableData}
          subFormState={subFormState}
          setSubFormState={setSubFormFullState}
          subFormErrors={subFormErrors}
          validateSubFormData={validateSubFormData}
          editForm={editForm}
        />
      )}
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item></Grid>
        <Grid item alignContent="right" justifyContent="right">
          <Grid container>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Total Credit : ${parseAndRound(
                      summary.totalCredit,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Total Debit :     ${parseAndRound(
                      summary.totalDebit,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
            {parseAndRound(summary.totalCredit, 4) !==
              parseAndRound(summary.totalDebit, 4) && (
              <Grid item>
                <Chip
                  label={
                    <Typography variant="button" component="h2">
                      {`Difference :     { ${parseAndRound(
                        parseAndRound(summary.totalCredit, 4) -
                          parseAndRound(summary.totalDebit, 4),
                        6
                      )} }`}
                    </Typography>
                  }
                  color="warning"
                  m={1}
                />
              </Grid>
            )}
          </Grid>

          {/* <Grid container>
            <Grid item>
              <h3>Total Credit</h3>
            </Grid>
            <Grid item>
              <h3>{parseAndRound(_.sumBy(tableData, "displayCredit"), 4)}</h3>
            </Grid>
            <Grid item>
              <h3>{parseAndRound(_.sumBy(tableData, "displayCredit"), 4)}</h3>
            </Grid>
          </Grid> */}
        </Grid>
      </Grid>
    </>
  );
}
export default GATrxFooter;
